module.exports = __webpack_public_path__ + "sz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sz.svg
// module id = 827
// module chunks = 0